import api from 'utils/api'

export const getGoogleOauthPromptScreen = () => {
  return api.get('/google_oauth/get_prompt_screen')
}

export const getAppleOauthPromptScreen = () => {
  return api.get('/apple_oauth/get_prompt_screen')
}
